import { useContext } from "react";
import FilterList from "../../components/filters/filter-list";
import ResourcesCardWrapper from "../../components/resource-card-wrapper";
import LanguageContext from "../../context/language";
import useUpdateFavoriteResources from "../../hooks/mutations/useUpdateFavoriteResources";
import useResources from "../../hooks/queries/useResources";
import useBreakpoint from "../../hooks/useBreakpoint";
import useFilters from "../../hooks/useFilters";
import useTealiumOnPageLoad from "../../utils/tealium";
import LoadingError from "../loading-error";

const PAGE_SIZE = 12;

const MyResources = ({ hub }) => {
  const { cmsLang: locale } = useContext(LanguageContext);

  const isMobile = useBreakpoint(991);
  const [query, setFilterData] = useFilters("resources");

  useTealiumOnPageLoad({ pageType: "Landing", pageSection1: "My Resources" });

  const {
    data: resources,
    error,
    isFetching,
    fetchNextPage,
  } = useResources({
    hub,
    query,
    my: true,
    pageSize: PAGE_SIZE,
  });

  const { mutateAsync: updateFav } = useUpdateFavoriteResources({
    // Invalidate all resources cache except current, on which optimistic update will be performed
    doInvalidateAllResources: true,
    // Invalidate my resources cache
    doInvalidateMyResources: false,
    doOptimisticUpdateMyResources: true,
    currentQueryKey: ["resources-my", PAGE_SIZE, locale, query, hub],
  });

  const handleUpdateFav = async ({ id, isDelete }) => {
    await updateFav({ id, isDelete });
  };

  return error ? (
    <LoadingError />
  ) : (
    <FilterList
      items={resources?.data}
      query={query}
      totalCounter={resources?.resultsAvailableCount}
      setFilterData={setFilterData}
      facetView={resources?.facetView}
      resourceType="resources"
      filterColumnOpen={!isMobile}
      hideFiltersEmpty={true}
    >
      <ResourcesCardWrapper
        resources={resources}
        loadMore={fetchNextPage}
        isLoading={isFetching}
        onUpdate={handleUpdateFav}
        favourites={true}
        search={query?.term}
      />
    </FilterList>
  );
};

export default MyResources;
